module.exports = __webpack_public_path__ + "static/assets/1d5818461fccb99d9f6174de915c6ccc.png";